import React, { useState } from 'react';
import { Box, List, ListItem, Collapse, ListItemIcon, ListItemText, CssBaseline, Drawer, Toolbar, ListItemButton, Badge, Typography } from '@mui/material/';

import { useNavigate, Outlet, useLocation } from "react-router-dom";
import InboxIcon from '@mui/icons-material/MoveToInbox';
import OutboxIcon from '@mui/icons-material/Outbox';
import LogoutIcon from '@mui/icons-material/Logout';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import BedroomParentIcon from '@mui/icons-material/BedroomParent';
import ConstructionIcon from '@mui/icons-material/Construction';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import SettingsIcon from '@mui/icons-material/Settings';
import PeopleIcon from '@mui/icons-material/People';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import NotificationsIcon from '@mui/icons-material/Notifications';
import MenuIcon from '@mui/icons-material/Menu';
import HelpCenterIcon from '@mui/icons-material/HelpCenter';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';

import './Navbar.css';

export default function Navbar() {
  const API_URL = 'https://api.workers.grupotel.com/';

  const regex = /(?:.(?!\/))+$/gm;

  let currLocation = '';
  const str = useLocation();
  let m;

  const updateCurrLocation = (match, groupIndex) => {
    currLocation = match;
  };

  while ((m = regex.exec(str.pathname)) !== null) {
    // This is necessary to avoid infinite loops with zero-width matches
    if (m.index === regex.lastIndex) {
      regex.lastIndex++;
    }
    // The result can be accessed through the `m`-variable.
    m.forEach(updateCurrLocation);
    currLocation = currLocation.substring(1);
  }

  const [openState, setOpenState] = useState({
    Pisos: false,
    Auditorias: false,
    Maquinas: false,
    Partes: true,
    // Agrega otros elementos según sea necesario
  });

  const toggleOpen = (element) => () => {
    setOpenState((prevState) => ({
      ...prevState,
      [element]: !prevState[element],
    }));
  };
  let userName = localStorage.getItem('nombreUsuario');
  let departmentId = localStorage.getItem('id_departamento');
  let userId = localStorage.getItem('id');

  const drawerWidth = 160;
  const navigate = useNavigate();
  const cerrarSesion = () => {
    //Recorremos los elementos guardados en el LocalStorage.
    localStorage.clear();
    window.location.reload();
  }

  const [drawerOpen, setDrawerOpen] = useState(true);
  const [cantidades, setCantidades] = useState({});

  const cantidadNotificaciones = () => {
    const fd = new FormData();
    fd.append("f", "partes.getResumenPartesYFacturas");
    fd.append("token", localStorage.getItem('token'));

    const requestOptions = {
      method: 'POST',
      body: fd
    };

    fetch(API_URL, requestOptions)
      .then(response => response.json())
      .then(result => {
        // console.log(result)
        setCantidades(result);
      })
      .catch(() => {
        console.log("Error Api. Obteniendo las notificaciones.");
      })
  }
  // cantidadNotificaciones();
  // console.log(cantidades)

  // Configuración de secciones y sub-secciones
  const sectionsConfig = {
    Partes: {
      label: "Partes",
      children: [
        { key: "Entradas", label: "Entradas", icon: <InboxIcon className="icono" />, badge: "partes", path: "/Partes/Entradas" },
        { key: "Salidas", label: "Salidas", icon: <OutboxIcon className="icono" />, path: "/Partes/Salidas" },
        {
          key: "PreConforme", label: "Pre Conformar", icon: <FactCheckIcon className="icono" />, badge: "facturas", path: "/Partes/PreConforme",
          condition: (userId, arr) => arr.includes("pre-conforme") || userId == 380
        }
      ]
    },
    Auditorias: { label: "Auditorias", children: [{ key: "Auditorias", label: "Auditorias", icon: <AssignmentTurnedInIcon className="icono" /> }] },
    Pisos: { label: "Habitaciones", children: [{ key: "Pisos", label: "Mapa", icon: <BedroomParentIcon className="icono" /> }] },
    Maquinas: {
      label: "Maquinas",
      children: [
        { key: "Maquinas", label: "Maquinas", icon: <InboxIcon className="icono" /> },
        { key: "Lecturas", label: "Lecturas", icon: <FactCheckIcon className="icono" /> },
        { key: "ConfMaquinas", label: "Configuración", icon: <SettingsIcon className="icono" />, condition: (userId, arr) => arr.includes("conf-maquinas") }
      ]
    },
    Usuarios: { // sección Configuración
      label: "Configuración",
      children: [
        { key: "Usuarios", label: "Usuarios", icon: <PeopleIcon className="icono" />, condition: (u, arr) => arr.includes("Usuarios") },
        { key: "Noticias", label: "Noticias", icon: <NotificationsIcon className="icono" />, condition: (u, arr) => arr.includes("Noticias") },
        { key: "Productos", label: "Productos", icon: <ProductionQuantityLimitsIcon className="icono" />, condition: (u, arr) => arr.includes("Productos") }
      ]
    },
    Documentos: {
      label: "Documentos",
      children: [
        { key: "SubirYConsultar", label: "Subir/Consultar", icon: <ConstructionIcon className="icono" />, condition: (u, arr) => arr.includes("SubirYConsultar") },
        { key: "FichasTecnicas", label: "Fichas Técnicas", icon: <AssignmentTurnedInIcon className="icono" />, condition: (u, arr) => arr.includes("FichasTecnicas") }
      ]
    },
    Ayuda: { label: "Ayuda", children: [{ key: "Manuales", label: "Manuales", icon: <HelpCenterIcon className="icono" /> }] }
  };

  let listItems = localStorage.getItem('secciones');
  let arr = listItems.split(',');

  // Normalizar arr: si viene SubirYConsultar o FichasTecnicas, añadimos Documentos
  const normalizedArr = Array.from(new Set([
    ...arr,
    (arr.includes("SubirYConsultar") || arr.includes("FichasTecnicas")) ? "Documentos" : null
  ].filter(Boolean)));

  let adjustedArr = [...normalizedArr];
  if (normalizedArr.includes("Productos") || normalizedArr.includes("Noticias")) {
    adjustedArr.push("Usuarios"); // 'Usuarios' es la sección Configuración
  }
  const finalArr = [...new Set(adjustedArr)];


  return (
    <div>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        {drawerOpen && (
          <Drawer
            sx={{
              width: drawerWidth,
              flexShrink: 0,
              '& .MuiDrawer-paper': {
                width: drawerWidth,
                boxSizing: 'border-box',
                background: '#002735'
              },
            }}
            variant="permanent"
            anchor="left"
          >
            {/* Botón para ocultar */}
            <ListItemButton onClick={() => setDrawerOpen(false)} className="boton-toggle-navbar icon">
              <MenuOpenIcon sx={{ color: 'white' }} />
            </ListItemButton>
            <Toolbar >
              <img id="logo" className='clicable' src="/logo.svg" alt="logo" onClick={() => { navigate('/' + 'Home', { replace: true }); cantidadNotificaciones(); }} />
            </Toolbar>
            <Typography className='textoUsuario clicable centrar' onClick={() => { navigate('/Home'); cantidadNotificaciones(); }}>
              {userName}
            </Typography>

            <br></br>
            <List className="quitarPadding">
              {finalArr.map(element => {
                const section = sectionsConfig[element];
                if (!section) return null;

                // Filtramos hijos visibles según condición
                const visibleChildren = section.children.filter(child => !child.condition || child.condition(userId, arr));
                if (visibleChildren.length === 0) return null;

                return (
                  <React.Fragment key={`fragment-${element}`}>
                    <ListItem key={`${element}-menu`} id={`${element}-menu`} className="quitarPadding colorSeleccion">
                      {!openState[element] && element === "Partes" && cantidades?.partes > 0 ? (
                        <Badge anchorOrigin={{ vertical: "top", horizontal: "right" }} className="notificacion" badgeContent={cantidades.partes}>
                          <ListItemButton onClick={toggleOpen(element)}>
                            <ListItemText className="navbar-text-padre">{section.label}</ListItemText>
                            {openState[element] ? <ExpandLess className="icono" /> : <ExpandMore className="icono" />}
                          </ListItemButton>
                        </Badge>
                      ) : (
                        <ListItemButton onClick={toggleOpen(element)}>
                          <ListItemText className="navbar-text-padre">{section.label}</ListItemText>
                          {openState[element] ? <ExpandLess className="icono" /> : <ExpandMore className="icono" />}
                        </ListItemButton>
                      )}
                    </ListItem>

                    <Collapse in={openState[element]} timeout="auto" unmountOnExit className="fondoCollapse">
                      {visibleChildren.map(child => {
                        const badgeValue = child.badge && cantidades?.[child.badge] > 0 ? cantidades[child.badge] : null;
                        return (
                          <ListItem
                            key={`list-item-${child.key}`}
                            className={currLocation === child.key ? "currLocation quitarPadding menuHijo" : "quitarPadding colorSeleccion menuHijo"}
                            id={`${child.key}`}
                            onClick={() => {
                              navigate(child.path || `/${child.key}`, { replace: true });
                              cantidadNotificaciones();
                            }}
                          >
                            {badgeValue ? (
                              <Badge anchorOrigin={{ vertical: "top", horizontal: "right" }} className="notificacion" badgeContent={badgeValue}>
                                <ListItemButton>
                                  <ListItemIcon className="icon">{child.icon}</ListItemIcon>
                                  <ListItemText className="navbar-text menuHijoTxt">{child.label}</ListItemText>
                                </ListItemButton>
                              </Badge>
                            ) : (
                              <ListItemButton>
                                <ListItemIcon className="icon">{child.icon}</ListItemIcon>
                                <ListItemText className="navbar-text menuHijoTxt">{child.label}</ListItemText>
                              </ListItemButton>
                            )}
                          </ListItem>
                        );
                      })}
                    </Collapse>
                  </React.Fragment>
                );
              })}
            </List>


            <List className='navbar-bottom ' >
              <ListItem key={"list-item-bottom"} className='quitarPadding'>
                <ListItemButton key={"list-item-button-Ajustes"} className='logout' onClick={() => { navigate('/' + 'Ajustes', { replace: true }); cantidadNotificaciones(); }}>
                  <ListItemIcon className="icon">
                    <SettingsIcon className="icono" />
                  </ListItemIcon>
                </ListItemButton>
                <ListItemButton key={"list-item-button-logout"} className='logout' onClick={cerrarSesion} >
                  <ListItemIcon className="icon">
                    <LogoutIcon className="cerrarSesion" />
                  </ListItemIcon>
                </ListItemButton>
              </ListItem>
            </List>
          </Drawer>
        )}
        {!drawerOpen && (
          <ListItemButton onClick={() => setDrawerOpen(true)} sx={{
            position: 'fixed',
            top: 14,
            // left: 10, 
            zIndex: 2000,
            color: 'white',
            background: '#002735',
            'border-radius': '4px'
          }}>
            <MenuIcon />
          </ListItemButton>
        )}
        <Box
          className='container'
          component="main"
          sx={{
            flexGrow: 1,
            bgcolor: 'background.default',
            p: 3,
            ml: drawerOpen ? `${drawerWidth}px` : '52px !important',
            // transition: 'margin 2s ease',
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </div>
  );
}